import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Card, Divider, Modal, Switch, Table, message } from 'antd'
import {
  getPartnerList,
  createPartner,
  updatePartner,
  deactivatePartner,
  restorePartner
} from '../../modules/apiPartner'
import { useDeepEffect } from '../../utils/hooks'
import ApiPartnerForm from './components/ApiPartnerForm'


const ApiPartner = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { partnerList, isLoading } = useSelector(
    (state) => ({
      partnerList: state.apiPartner.partnerList,
      isLoading: state.apiPartner.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    dispatch(getPartnerList())
  }, [])

  const onCreate = () => {
    setFormData({})
    setVisible(true)
  }

  const onEdit = (record) => {
    setFormData(record)
    setVisible(true)
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormData({})
  }

  const onOk = async (data) => {
    const ok =
      formData && formData.id
        ? await dispatch(updatePartner(formData.id, data))
        : await dispatch(createPartner(data))
    if (ok) {
      message.success('บันทึกสำเร็จ')
      onCloseModal()
      await dispatch(getPartnerList())
    }
  }

  const onDeactivate = (record) => {
    Modal.confirm({
      title: `ปิดใช้งาน "${record.name}" ?`,
      content:
        'Partner จะหายจากรายการที่ร้านเห็น แต่การเชื่อมต่อเดิมของร้านยังอยู่ เปิดใช้งานกลับได้ภายหลัง',
      okText: 'ปิดใช้งาน',
      okType: 'danger',
      cancelText: 'ยกเลิก',
      onOk: async () => {
        const ok = await dispatch(deactivatePartner(record.id))
        if (ok) {
          message.success('ปิดใช้งานสำเร็จ')
          await dispatch(getPartnerList())
        }
      }
    })
  }

  const onRestore = async (record) => {
    const ok = await dispatch(restorePartner(record.id))
    if (ok) {
      message.success('เปิดใช้งานสำเร็จ')
      await dispatch(getPartnerList())
    }
  }

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' },
    {
      title: 'โลโก้',
      dataIndex: 'logoUrl',
      key: 'logoUrl',
      width: 90,
      align: 'center',
      render: (logoUrl) =>
        logoUrl ? <img src={logoUrl} alt="logo" style={{ height: 32 }} /> : '-'
    },
    { title: 'ชื่อ', dataIndex: 'name', key: 'name', width: 160 },
    { title: 'Base URL', dataIndex: 'baseUrl', key: 'baseUrl' },
    {
      title: 'Token Endpoint',
      dataIndex: 'partnerTokenEndpoint',
      key: 'partnerTokenEndpoint'
    },
    {
      title: 'สถานะ',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 100,
      align: 'center',
      render: (isActive, record) => (
        <Switch
          size="small"
          checked={isActive}
          onChange={(checked) =>
            checked ? onRestore(record) : onDeactivate(record)
          }
        />
      )
    },
    {
      title: '',
      key: 'action',
      width: 100,
      align: 'center',
      render: (_text, record) => (
        <span>
          <Link to={`/api-partner/${record.id}`}>
            <Button size="small" shape="circle" icon="eye" />
          </Link>
          <Divider type="vertical" />
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={() => onEdit(record)}
          />
        </span>
      )
    }
  ]

  return (
    <Card
      title="API Partner"
      extra={
        <Button type="primary" onClick={onCreate}>
          สร้าง API Partner
        </Button>
      }>
      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={partnerList}
        pagination={false}
      />
      <ApiPartnerForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default ApiPartner
